import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Spinner from '~/js/components/general/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper';
import SearchPanel from '~/js/components/search-for-agents/SearchPanel';
import AgentItem from '~/js/components/search-for-agents/AgentItem';

const fetch = new GoFetch();

const internals = {
  countries: window.beaches_app.page.countries.filter(el => {
    const idList = [210, 34];

    return idList.includes(el.id);
  })
};

class SearchAgents extends Component {
  state = {
    countriesChecked: {},
    searchData: {},
    zipCode: ''
  };

  getData = () => {
    const { countriesChecked, zipCode } = this.state;
    const { type } = this.props;
    const { code } = Object.values(countriesChecked)[0];

    const data = {
      countryCode: code,
      zipCode: zipCode
    };

    let url;

    if (type === 'travel') {
      url = '/travel-agents/fetchTravelAgents/';
    } else {
      url = '/travel-agents/fetchWeddingExpTravelAgents/';
    }

    fetch.post(url, null, data).then(response => {

      if (response.status === 'fail' || response.status === 'error') {
        this.setState({ error: 'Server error, please try again later.' });
      }

      const searchData = {
        agentsData:
          type === 'travel'
            ? response.data.travelAgents
            : response.data.weddingExpTravelAgents,
        zip: zipCode,
        countryCode: code
      };

      this.setState({ searchData });
    });
  };

  handleSelect = item => {
    this.setState({
      countriesChecked: { [item.id]: item },
      error: null
    });
  };

  handleChange = e => {
    if (e.target.validity.valid) {
      this.setState({ zipCode: e.target.value.toUpperCase(), error: null });
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    const { countriesChecked, zipCode } = this.state;

    if (Object.keys(countriesChecked).length === 0) {
      this.setState({ error: 'Please select a country' });

      return;
    }

    const regExp =
      '210' in countriesChecked
        ? /^(\d{5})[\s-]?(\d{4})?$/
        : /^([ABCEGHJKLMNPRSTVXY]\d[A-Za-z])[ -]?(\d[A-Za-z]\d)$/i;

    if (!regExp.test(zipCode)) {
      this.setState({ error: 'Please enter a valid  postal / zip code' });
    } else {
      this.setState({ searchData: {}, isSubmitting: true });

      this.getData();
    }
  };

  render() {
    const {
      countriesChecked,
      searchData: { agentsData, zip, countryCode },
      zipCode,
      isSubmitting,
      error
    } = this.state;
    const { countries } = internals;

    let result;
    let noFoundText;

    switch (this.props.type) {
      case 'travel':
        noFoundText = 'travel agents';
        break;
      case 'weddings':
        noFoundText = <span>WeddingMoons{<sup>&reg;</sup>} Specialist</span>;
        break;
      default:
        noFoundText = 'agents';
        break;
    }

    if (isSubmitting) {
      result = <Spinner />;
    }

    if (agentsData && agentsData.length) {
      result = (
        <Fragment>
          <h3 className="results-title">
            Results For:{' '}
            <span className="results-title-zip">
              {zip}, {countryCode}
            </span>
          </h3>

          <div className="row">
            {agentsData.map((el, index) => (
              <AgentItem
                key={index}
                className="xs-12 lg-4"
                data={el}
              />
            ))}
          </div>
        </Fragment>
      );
    } else if (agentsData) {
      result = (
        <h3 className="results-title">
          No {noFoundText} found for this zip code:{' '}
          <strong className="results-title-zip">
            {zip}, {countryCode}
          </strong>
        </h3>
      );
    }

    return (
      <div className="search-agents container">
        <SearchPanel
          countries={countries}
          countriesChecked={countriesChecked}
          zipCode={zipCode}
          error={error}
          onSelect={this.handleSelect}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />

        {result}
      </div>
    );
  }
}

SearchAgents.propTypes = {
  type: PropTypes.string
};

SearchAgents.defaultProps = {
  type: 'travel'
};

export default SearchAgents;
